import { post } from "@insite/client-framework/Services/ApiService";

export interface ProductRequestForm {
    firstName: string;
    lastName: string;
    email: string;
    brandName: string;
    productNumber?: string;
    addionalProductInfo?: string;
}

export interface ProductRequestResponse {
    message?: string;
    status?: string;
}

const apiUrl = "/api/v2/productrequest";

export function submitProductRequestForm(data: ProductRequestForm) {
    return post<any>(apiUrl, data) as Promise<ProductRequestResponse>;
}
